module.exports = __webpack_public_path__ + "img/certificado.873e0fe8.png";